const { angular } = window;

angular
  .module('wcm.reporting')
  .controller('reportingViewCampaignsCtrl', function(
    $q,
    $scope,
    $state,
    $rootScope,
    $controller,
    reportingFactory,
    analyticsFactory2,
    analyticsRequestsFactory,
    analyticsPresetsFactory
  ) {
    $controller('reportingViewAnalyticsCtrl', { $scope });

    // eslint-disable-next-line no-multi-assign
    const options = ($scope.options = angular.extend($scope.options, {
      blocks: analyticsFactory2.exportPresets.general,
      campaigns: []
    }));
    // eslint-disable-next-line no-multi-assign
    const state = ($scope.state = angular.extend($scope.state, {
      handlersType: 'campaigns',
      manageBlocks: {
        campaignsFilter: [],
        dataByComparisonCampaigns: {}
      }
    }));
    state.blocksState = angular.copy(
      analyticsPresetsFactory.getSystemPreset(state.handlersType).data
        .analyticBlocks
    );

    // eslint-disable-next-line no-multi-assign
    const handlers = ($scope.handlers = angular.extend($scope.handlers, {
      prepareDataForBlock(name, data) {
        let filters = null;
        let handler;
        if (name === 'dataByCitiesAndCountriesSiteLocation') {
          handler = 'getDataByCitiesAndCountries';
          filters = { dataFrom: 'siteLocation' };
        } else if (name === 'dataByCitiesAndCountriesSocialNetworks') {
          handler = 'getDataByCitiesAndCountries';
          filters = { dataFrom: 'socialNetworks' };
          state.chartsData.dataByCitiesAndCountriesSocialNetworks = data;
        } else {
          handler = handlers.getRequestHandlerByBlockName(name);
        }
        return handlers
          .getDataForBlock(handler, filters, name, data)
          .then(function(data) {
            if (name === 'dataByCitiesAndCountriesSocialNetworks') {
              state.chartsData.dataByCitiesAndCountries = data;
            }
          });
      },
      prepareChartsData(report) {
        $scope.handlers.prepareChartsDataDefault(report);
        state.manageBlocks.dataByComparisonCampaigns = {
          values1: state.settings.collapsedValues.values1 || {},
          values2: state.settings.collapsedValues.values2 || {}
        };
        state.manageBlocks.campaignsFilter = options.campaigns.map(function(
          cam
        ) {
          return cam.name;
        });
      },
      refreshCurrentReport() {
        return $scope.handlers.refreshReport(state).then(function() {
          $scope.init();
        });
      },
      init: function init() {
        const noId = $scope.parentInit();
        if (!noId) {
          return false;
        }

        if ($rootScope.isHardlink) {
          return handlers.getReportByHardlink($state.params.id);
        }

        if (!handlers.hasViewPermission()) {
          return false;
        }
        if (!$rootScope.isHardlink) {
          return reportingFactory.getCampaignsReport(state).then(function(res) {
            options.campaigns = res.data.settings.campaignData;
            return res;
          }, handlers.showNoWas);
        }
        return undefined;
      }
    }));
  });
